import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import objectPath from 'object-path';
import { rem } from 'polished';
import { bp, megaText } from 'Styles/helpers';
import screen from 'superior-mq';
import Carousel from '../../carousel';
import CircleText from '../../svg/w4w-circle-text.svg';
import LogoMark from '../../svg/w4w-logo-mark.svg';
import LazyImg from '../../lazy-img';

const carouselStyles = css`
  .flickity-button {
    &.previous {
      left: calc(5% - 46px);

      ${screen.above('1800px', `
        left: calc(((100vw - 1650px) / 2) - 45px);
      `)}

      ${screen.below(bp.laptopSm, `
        left: calc(5% - 40px);
      `)}

      ${screen.below(bp.mobile, `
        left: 5%;
      `)}
    }

    &.next {
      right: calc(5% - 46px);

      ${screen.above('1800px', `
        right: calc(((100vw - 1650px) / 2) - 45px);
      `)}

      ${screen.below(bp.laptopSm, `
        right: calc(5% - 40px);
      `)}

      ${screen.below(bp.mobile, `
        right: 5%;
      `)}
    }

    .flickity-button-icon {
      margin-top: 0;
    }
  }
`;

const ProgramCarousel = ({ slides }) => {
  const slidesWithPhoto = slides.length > 0 && slides.filter(slide => objectPath.has(slide, 'photo.file.url'));

  if (slides.length < 1
    || slidesWithPhoto.length < 1) {
    return null;
  }

  return (
    <CarouselSection>

      <CaourselHeadline>Gallery</CaourselHeadline>
      <W4WCircleText />
      <W4WLogoMark />

      <Carousel
        wrapAround={slidesWithPhoto.length > 3}
        prevNextButtons
        styles={carouselStyles}
      >

        {slidesWithPhoto.map((slide, i) => {
          // eslint-disable-next-line react/no-array-index-key
          if (!objectPath.has(slide, 'photo.file.url')) return <div key={i} />;

          return (
            <CarouselFigure key={slide.photo.file.fileName}>
              <LazyImg
                width={1650}
                height={920}
                src={`${slide.photo.file.url}?w=1650&h=920&q=80&fm=jpg&fl=progressive`}
                alt={slide.caption}
              />

              {!!slide.caption &&
                <ImageCaption>{slide.caption}</ImageCaption>
              }

            </CarouselFigure>
          );
        })}

      </Carousel>

    </CarouselSection>
  );
};

const CarouselSection = styled.section`
  position: relative;
  text-align: center;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
    fill: #fff;
    pointer-events: none;
  }
`;

const CarouselFigure = styled.figure`
  width: 90%;
  padding: 0 10px;
  max-width: 1650px;

  ${screen.below(bp.mobile, `
     padding: 0 5px;
  `)}
`;

const ImageCaption = styled.figcaption`
  margin-top: 14px;
  font-size: ${rem(14)};

  ${screen.below(bp.mobile, `
    margin-top: 10px;
  `)}
`;

const W4WCircleText = styled(CircleText)`
  width: 210px;
  height: 210px;

  ${screen.below(bp.mobile, `
    display: none;
  `)}
`;

const W4WLogoMark = styled(LogoMark)`
  width: 60px;
  height: 40px;

  ${screen.below(bp.mobile, `
    display: none;
  `)}
`;

const CaourselHeadline = styled.h2`
  ${megaText()}
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 2;
  color: ${props => props.theme.blue};
  writing-mode: vertical-lr;
  white-space: nowrap;
  transform: translate(-50%, -23.2%) scale(-1);
  pointer-events: none;

  @supports (mix-blend-mode: multiply) {
    mix-blend-mode: multiply;
  }

  ${screen.below(bp.mobile, `
    display: none;
  `)}
`;

ProgramCarousel.propTypes = {
  slides: PropTypes.array,
};

ProgramCarousel.defaultProps = {
  slides: [],
};

export default ProgramCarousel;
